import logo from 'assets/images/Logo.svg';
import Theme from 'utils/theme';
import loginImg from 'assets/images/Image.svg';

const orgConfig = {
  product: '00f45cb6-b611-456f-9863-ab7152a4ba71',
  logo,
  loginImg,
  Theme,
  privileges: {
    usersView: true,
    usersCreate: true,
    usersEdit: true,
    usersDelete: true,
    rolesView: true,
    rolesCreate: true,
    rolesEdit: true,
    rolesDelete: true,
  },
};
export default orgConfig;
